import { createAction, props } from '@ngrx/store';
import { Correspondence, DossierInvoices, Templates } from './dossier-invoice.model';
import { PaymentType } from '../PaymentType/payment-type.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier invoices',
    props<{ id: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier invoices success', 
    props<{ listData: DossierInvoices[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier invoices failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier invoices',
    props<{id: string, dossierId: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier invoices success', 
    props<{ singleData: any, paymentTypes: PaymentType[] }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier invoices failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record dossier invoices',
    props<{ newData: any, dossierId: string }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record dossier invoices success'
);
export const addRecordFailure = createAction(
    '[Data] Add record dossier invoices failure',
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier invoices',
    props<{ dossierId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier invoices success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier invoices failure',
    props<{ error: string }>()
);


// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete dossier invoices',
    props<{ dossierId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete dossier invoices success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete dossier invoices failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state dossier invoices',
);